import React from 'react';
import './TeamPyramid.css';

const teamPhoto = (fileName) => `/Team/${encodeURIComponent(fileName)}`;

const TEAM_NODES = [
  {
    id: 'president',
    x: '50%',
    y: '11.829%',
    fileName: 'AG_President.jpeg',
    name: 'Adham El-Gammal',
    role: 'President',
    size: '100px',
  },
  {
    id: 'vp',
    x: '50%',
    y: '34.291%',
    fileName: 'Agdad sora aandi aho.jpeg',
    name: 'Chehab Mosaad',
    role: 'Vice President',
    size: '100px',
  },
  {
    id: 'middle-1',
    x: '50%',
    y: '60.837%',
    fileName: 'Adham samir Events manager.jpeg',
    name: 'Adham Samir',
    role: 'Events manager',
    size: '100px',
  },
  {
    id: 'middle-2',
    x: '13.141%',
    y: '60.837%',
    fileName: 'Razane Abdelrazek Project manager.jpeg',
    name: 'Razane Abdelrazek',
    role: 'Project manager',
    size: '100px',
  },
  {
    id: 'middle-3',
    x: '31.571%',
    y: '60.837%',
    fileName: 'Farida Engine Project manager.jpeg',
    name: 'Farida Engine',
    role: 'Project manager',
    size: '100px',
  },
  {
    id: 'middle-4',
    x: '66.314%',
    y: '60.837%',
    fileName: 'zohra elsemary Project manajer.jpeg',
    name: 'Zohra Elsemary',
    role: 'Project manager',
    size: '100px',
  },
  {
    id: 'middle-5',
    x: '82.031%',
    y: '60.837%',
    fileName: 'Seif Kamel QA.jpeg',
    name: 'Seif Kamel',
    role: 'Digital Services Manager',
    size: '100px',
  },
  {
    id: 'base-1',
    x: '42.69%',
    y: '87.518%',
    fileName: 'Aida amr Events specialist.jpeg',
    name: 'Aida Amr',
    role: 'Events specialist',
    size: '100px',
  },
  {
    id: 'base-2',
    x: '57.31%',
    y: '87.518%',
    fileName: 'Hawraa elanany Events specialist.jpeg',
    name: 'Hawraa Elanany',
    role: 'Events specialist',
    size: '100px',
  },
];

const TeamNode = ({ name, role, image, x, y, size, nodeId, nowrapName = false }) => (
  <figure
    className="team-tree-node"
    data-node-id={nodeId}
    style={{ left: x, top: y, '--avatar-size': size }}
  >
    <div className="team-tree-node-avatar" aria-hidden="true">
      <img src={image} alt={role ? `${name}, ${role}` : name} loading="lazy" />
    </div>
    <figcaption className={nowrapName ? 'team-tree-node-caption team-tree-node-caption--nowrap' : 'team-tree-node-caption'}>
      <p className={nowrapName ? 'team-tree-node-name team-tree-node-name--nowrap' : 'team-tree-node-name'}>{name}</p>
      {role ? <p className="team-tree-node-role">{role}</p> : null}
    </figcaption>
  </figure>
);

const TeamPyramid = () => (
  <div className="team-tree-layout" aria-label="Organigramme de l'équipe ADEEF">
    <div className="team-tree-frame">
      <img className="team-tree-background" src="/1-1-5-2(2).svg" alt="" aria-hidden="true" />

      <div className="team-tree-overlay">
        {TEAM_NODES.map((member) => (
          <TeamNode
            key={member.id}
            name={member.name}
            role={member.role}
            image={teamPhoto(member.fileName)}
            x={member.x}
            y={member.y}
            size={member.size}
            nodeId={member.id}
            nowrapName={member.id === 'president' || member.id === 'vp'}
          />
        ))}
      </div>
    </div>
  </div>
);

export default TeamPyramid;